export class ApiError extends Error {
  constructor(public status: number, message: string, public body?: unknown) {
    super(message);
  }
}

/** FastAPI's HTTPException serializes as {"detail": "..."} — surface that
 * verbatim (e.g. "Недостаточно средств...") instead of a generic "HTTP 402"
 * whenever it's present. */
export function apiErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const detail = (err.body as { detail?: string } | undefined)?.detail;
    if (typeof detail === "string") return detail;
    return err.message;
  }
  return err instanceof Error ? err.message : "Что-то пошло не так";
}

export async function api<T = unknown>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const res = await fetch(path.startsWith("/") ? path : `/api/v1/${path}`, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(init.headers || {}),
    },
    ...init,
  });
  if (!res.ok) {
    let body: unknown = undefined;
    try { body = await res.json(); } catch {}
    throw new ApiError(res.status, `HTTP ${res.status} ${res.statusText}`, body);
  }
  if (res.status === 204) return undefined as T;
  return res.json() as Promise<T>;
}
